import { useContext, useEffect, useState } from "react";
import adminStyles from "../styles/AdminView.module.css";
import buttonStyles from "../styles/Button.module.css";
import cardStyles from "../styles/Card.module.css";
import tableStyles from "../styles/Table.module.css";

import { GlobalContext } from "../App";
import { DistributedEquipment, DistributedEquipmentCount, Equipment } from "../types";
import { createEquipment, deleteEquipment, fetchDistributedEquipment, fetchEquipment } from "../api";

export default function AdminEquipment() {
    const { globalSite, setSite } = useContext(GlobalContext);
    
    const [distributedEquipment, setDistributedEquipment] = useState<DistributedEquipmentCount[]>([]);
    const [equipment, setEquipment] = useState<Equipment[]>([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalTitle, setModalTitle] = useState("");

    const [newDescription, setNewDescription] = useState("");

    useEffect(() => {
        if (globalSite) {
            fetchEquipment(globalSite).then(setEquipment);
            fetchDistributedEquipment(globalSite).then(setDistributedEquipment);
        }
    }, [globalSite])

    function openModal(currentEquipment: Equipment | null) {

        if (currentEquipment) {
            setModalTitle("Edit Equipment")
        } else {
            setModalTitle("Add New Equipment")
        }

        setModalOpen(true)
    }
    function closeModal()  {
        setModalOpen(false);
        setModalTitle("");
    }
    
    function handleAddOrEditEquipment() {
        createEquipment(globalSite, newDescription).then(() => {
            fetchEquipment(globalSite).then(setEquipment)
            setNewDescription("")
        })
    }

    function removeEquipment(e:Equipment) {
        console.log(e)
        deleteEquipment(globalSite, e.id).then(() =>
            fetchEquipment(globalSite).then(setEquipment)
        )
    }

    return (
        <>
        <section>
            <div className={adminStyles.section}>
                <div className={adminStyles.header}>
                    <h3>Equipment</h3>
                    <button
                        className={`${buttonStyles.button} ${buttonStyles.primary}`}
                        onClick={() => openModal(null)}
                    >
                        Available Equipment
                    </button>
                </div>
                <table className={tableStyles.table}>
                    <thead>
                        <tr>
                            <th>Description</th>
                            <th style={{ textAlign: "center" }}>Number Distributed</th>
                        </tr>
                    </thead>
                    <tbody>
                        {distributedEquipment.map((e) => (
                            <tr key={e.description}>
                                <td>{e.description}</td>
                                <td style={{ width: "20%", textAlign: "center" }}>{e.count}</td>
                            </tr>
                        ))}
                        {distributedEquipment.length === 0 && (
                            <tr>
                                <td colSpan={2} style={{ textAlign: "center", padding: 16 }}>
                                    No Equipment Found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </section>
        {/* Available Equipment modal */}
        {modalOpen && (
            <div 
                className={adminStyles.modalOverlay}
                onClick={closeModal}
            >
                <div
                    className={`${cardStyles.card} ${adminStyles.modalContent}`}
                    onClick={(e) => e.stopPropagation()}
                >
                    <h3>Equipment</h3>
                    <div
                        className={adminStyles.modalField}
                        style={{
                            display: "flex"
                        }}
                    >
                        <label htmlFor="newDescription">New Equipment</label>
                        <input
                            id="newDescription"
                            value={newDescription}
                            onChange={(e) => setNewDescription(e.target.value)}
                        />
                        <button
                            onClick={handleAddOrEditEquipment}
                            className={`${buttonStyles.buttonSmall} ${buttonStyles.primary}`}
                        >
                            Add
                        </button>
                    </div>
                    <h4>Available Equipment</h4>
                    <table className={tableStyles.table}>
                        <thead>
                            <tr>
                                <th>Description</th>
                                <th style={{ textAlign: "center" }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {equipment.map((e) => (
                                <tr key={e.description}>
                                    <td>{e.description}</td>
                                    <td style={{ width: "20%", textAlign: "center" }}>
                                        <button
                                            className={`${buttonStyles.buttonSmall} ${buttonStyles.close}`}
                                            onClick={() => removeEquipment(e)}
                                        >
                                            Remove
                                        </button>
                                    </td>
                                </tr>
                            ))}
                            {equipment.length === 0 && (
                                <tr>
                                    <td colSpan={2} style={{ textAlign: "center", padding: 16 }}>
                                        No Equipment Found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        )}
        </>
    )
}
